module.exports = __webpack_public_path__ + "img/ifc-blog.3e9eb37.png";